import React from 'react';
import UserIcon from '@make-software/cspr-ui/dist/lib/assets/icons/ic-user.svg';
import { useTranslation } from 'react-i18next';
import { ACCOUNT_DETAILS_PATH } from '../../../router/paths';
import { useCustomHistory } from '../../../router/navigation';
import { buildRouterPath } from '../../../router/utils';
import { useWalletService } from '../../../services';
import { AccountMenuItem } from '@make-software/csprclick-ui';

export const ViewAccountMenuItem = () => {
  const { t } = useTranslation();
  const walletService = useWalletService();
  const history = useCustomHistory();

  const redirectToAccountPage = () => {
    walletService.publicKey &&
      history.push(
        buildRouterPath(
          ACCOUNT_DETAILS_PATH,
          { id: walletService.publicKey },
          undefined
        )
      );
  };

  return (
    <AccountMenuItem
      label={t('View Account')}
      onClick={redirectToAccountPage}
      icon={UserIcon}
    />
  );
};
